module.exports = __webpack_public_path__ + "img/ic_optimism@2x.6c2a40c7.png";